import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useRef, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken } from "views/utils/CallApi";
import { postApiDataWithToken } from "views/utils/CallApi";
import * as mb from "views/common/MessageBox";
import { getRef, getRefSelect, getRefNumber } from "../../../utils/InputHelp";
import * as Validation from "../../../utils/Validation";
import { CtxAuth } from "views/utils/Contexts";

interface IFMailHistory {
    senderMail: string,
    senderName: string,
    smtpAuthentication: string,
    smtpSecurity: string,
    smtpPort: number,
    smtpUsername: string,
    smtpPw: string,
    smtpHost: string
}

export function Mail(): JSX.Element{

    const cua = useContext(CtxAuth); 
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [mailHistory, setMailHistory] = useState<IFMailHistory[]>();
    const senderMail = useRef<HTMLInputElement>(null);
    const senderName = useRef<HTMLInputElement>(null);
    const smtpAuthentication = useRef<HTMLSelectElement>(null);
    const smtpSecurity = useRef<HTMLSelectElement>(null);
    const smtpPort = useRef<HTMLInputElement>(null);
    const smtpUsername = useRef<HTMLInputElement>(null);
    const smtpPw = useRef<HTMLInputElement>(null);
    const smtpHost = useRef<HTMLInputElement>(null);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);

    
    function clickSubmit(){

        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);

        //バリデーションチェック
        let errmsg:string;
        
        //差出人メールアドレス
        errmsg = Validation.checkEmptyTextBox(getRef(senderMail), "差出人メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(senderMail), 256, "差出人メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkMailRule(getRef(senderMail), "差出人メールアドレス")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //差出人名
        errmsg = Validation.checkEmptyTextBox(getRef(senderName), "差出人名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(senderName), 200, "差出人名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //SMTPポート
        errmsg = Validation.checkEmptyTextBox(getRef(smtpPort), "SMTPポート")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkRangeNumber(getRefNumber(smtpPort), 0, 65535, "SMTPポート")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkPositiveInteger(getRefNumber(smtpPort), "SMTPポート")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //SMTPユーザー名
        if (getRefSelect(smtpAuthentication) === "1"){
            errmsg = Validation.checkEmptyTextBox(getRef(smtpUsername), "SMTPユーザー名")
            if (errmsg){
                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
                //ボタンを活性にする
                setSubmitDisabled(false);
                return false;
            }
        }
        errmsg = Validation.checkLengthOver(getRef(smtpUsername), 200, "SMTPユーザー名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkHankakuRule(getRef(smtpUsername), "SMTPユーザー名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }

        //SMTPパスワード
        if (getRefSelect(smtpAuthentication) === "1"){
            errmsg = Validation.checkEmptyTextBox(getRef(smtpPw), "SMTPパスワード")
            if (errmsg){
                setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
                //ボタンを活性にする
                setSubmitDisabled(false);
                return false;
            }
        }
        errmsg = Validation.checkLengthOver(getRef(smtpPw), 200, "SMTPパスワード")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkHankakuRule(getRef(smtpPw), "SMTPパスワード")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        
        //SMTPホスト
        errmsg = Validation.checkLengthOver(getRef(smtpHost), 256, "SMTPホスト")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        errmsg = Validation.checkHankakuRule(getRef(smtpHost), "SMTPホスト")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            //ボタンを活性にする
            setSubmitDisabled(false);
            return false;
        }
        

        //メール変更処理
        postApiDataWithToken('/management/settings/mail',
            {'mail_from': getRef(senderMail), 'mail_from_name': getRef(senderName), 'smtp_authentication': getRefSelect(smtpAuthentication), 'smtp_security': getRefSelect(smtpSecurity), 'smtp_port': getRefNumber(smtpPort), 'smtp_user_name': getRef(smtpUsername), 'smtp_password': getRef(smtpPw), 'smtp_host': getRef(smtpHost)},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"メール設定が完了しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"メールの設定に失敗しました。"});
                }
                //ボタンを活性にする
                setSubmitDisabled(false);
            }
        );
          
    }

    useEffect(function(){       

        //初期値取得
        const mHistory:IFMailHistory[] = [];

        getApiDataWithToken('/management/settings/system',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        mHistory.push({senderMail:res.data.system_list[0].mail_from, senderName:res.data.system_list[0].mail_from_name, smtpAuthentication:res.data.system_list[0].smtp_authentication, smtpSecurity:res.data.system_list[0].smtp_security, smtpPort:res.data.system_list[0].smtp_port, smtpUsername:res.data.system_list[0].smtp_user_name, smtpPw:res.data.system_list[0].smtp_password, smtpHost:res.data.system_list[0].smtp_host});
                        setMailHistory(mHistory);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">メール設定</h2>
                {mailHistory?.map(function(val, idx){
                    return(
                        <div key={idx} className="settings-wrap-short">
                            <div className="settings-block">
                                <h3 className="settings-title-h3">メール送信元情報</h3>
                                <div className="settings-form">
                                <div className="form-row">
                                    <div className="form-row-title">差出人メールアドレス</div>
                                    <div className="form-row-input"><input type="text" ref={senderMail} defaultValue={val.senderMail}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">差出人名</div>
                                    <div className="form-row-input"><input type="text" ref={senderName} defaultValue={val.senderName}/></div>
                                </div>
                                </div>
                            </div>
                            <div className="settings-block">
                                <h3 className="settings-title-h3">メールサーバー設定</h3>
                                <div className="settings-form">
                                <div className="form-row">
                                    <div className="form-row-title">SMTP認証</div>
                                    <div className="form-row-input">
                                    <div className="select">
                                        <select ref={smtpAuthentication} defaultValue={val.smtpAuthentication}>
                                        <option value="0">いいえ</option>
                                        <option value="1">はい</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">SMTPセキュリティ</div>
                                    <div className="form-row-input">
                                    <div className="select">
                                        <select ref={smtpSecurity} defaultValue={val.smtpSecurity}>
                                        <option value="なし">なし</option>
                                        <option value="SSL">SSL</option>
                                        <option value="TLS">TLS</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">SMTPポート</div>
                                    <div className="form-row-input"><input type="number" min="0" max="65535" className="input-size-s" ref={smtpPort} defaultValue={val.smtpPort}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">SMTPユーザー名</div>
                                    <div className="form-row-input"><input type="text" ref={smtpUsername} defaultValue={val.smtpUsername}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">SMTPパスワード</div>
                                    <div className="form-row-input"><input type="password" ref={smtpPw} defaultValue={val.smtpPw}/></div>
                                </div>
                                <div className="form-row">
                                    <div className="form-row-title">SMTPホスト</div>
                                    <div className="form-row-input"><input type="text" ref={smtpHost} defaultValue={val.smtpHost}/></div>
                                </div>
                                </div>
                            </div>
                            <button className="btn-primary margin-tb-20" onClick={clickSubmit} disabled={submitDisabled}>変更を保存</button>
                        </div>
                    )
                })}
            </div>
        </AdminFrame>
    )
}